module.exports = __webpack_public_path__ + "img/34_50.4a35a195.png";